import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';

export const SubscriptionWarningOverlay = ({ warning, navigate, onDismiss }) => {
  if (!warning || (!warning.locked && !warning.grace_period)) return null;

  return (
    <div className="fixed inset-x-0 top-0 bottom-[65px] z-[9998] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 sm:inset-0 sm:p-4" data-testid="subscription-warning-overlay">
      <div className="bg-white sm:rounded-2xl w-full sm:max-w-md lg:max-w-3xl p-6 text-center shadow-2xl sm:max-h-[75vh] overflow-y-auto rounded-2xl">
        <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${warning.locked ? 'bg-red-100' : 'bg-orange-100'}`}>
          <AlertTriangle size={32} className={warning.locked ? 'text-red-500' : 'text-orange-500'} />
        </div>
        <h2 className="text-lg font-bold text-gray-900 mb-2">
          {warning.locked ? 'Paneliniz Kilitlendi' : 'Abonelik Uyarısı'}
        </h2>
        <p className="text-sm text-gray-600 mb-4">
          {warning.locked
            ? 'Abonelik süreniz sona ermiştir. Paneli kullanmaya devam etmek için aboneliğinizi yenileyin.'
            : `Panelinizin kapanmasına son ${warning.days_remaining} gün. Lütfen aboneliğinizi yenileyin.`}
        </p>
        <div className="space-y-2">
          <Button
            onClick={() => navigate('/settings')}
            className="w-full rounded-full bg-[#6b6de3] hover:bg-[#5658c4] h-12 font-semibold"
            data-testid="renew-subscription-btn"
          >
            Aboneliği Yenile
          </Button>
          {!warning.locked && (
            <Button
              variant="ghost"
              onClick={onDismiss}
              className="w-full rounded-full text-[#8E8E93]"
            >
              Daha Sonra
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
